/**
 * Component: M23 Testimonial Slider 
 * 
 */
'use strict';

export class Testimonial
{
  constructor()
  {
    this.selectors = {
      component: $('.c-v4-m23-testimonial-slider'),
      sliders:   $('.c-v4-m23-testimonial-slider .slick-slider')
    };
  }

  init()
  {
    if ( ! this.selectors.component.length ) return;

    this.init_slick_carousel();
  }

  init_slick_carousel()
  {
    this.selectors.sliders.on('init reInit afterChange', function( event, slick, currentSlide )
    {
      if ( slick.slideCount > 1 )
      {
        document.getElementById('c-v4-m23-testimonial-slider-pager').innerHTML = ((currentSlide ? currentSlide : 0) + 1) + ' / ' + slick.slideCount;
      }
    });

    this.selectors.sliders.each(function()
    {
      $(this).slick({
        infinite:       true,
        appendArrows: ".c-v4-m23-testimonial-slider--slick-containe",
        slidesToScroll: 1,
        slidesToShow:   1,
        prevArrow: $('.c-v4--slick-arrow-left'),
        nextArrow: $('.c-v4--slick-arrow-right'),
      });
    });
  }
}